<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>内容版块</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/section/list' }">版块列表</el-breadcrumb-item>
        <el-breadcrumb-item>版块内容</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">版块内容</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleSectionItemAdd"
          >添加内容</el-button>
        </div>
      </div>
    </div>
    <div class="info card">
      <div class="info-item">
        <span class="label">版块标题：</span>
        <span class="value">{{section.title}}</span>
      </div>
      <el-divider
        class="divider"
        direction="vertical"
      ></el-divider>
      <div class="info-item">
        <span class="label">版块位置：</span>
        <span class="value">{{sites[section.site] || '--'}}</span>
      </div>
      <el-divider
        class="divider"
        direction="vertical"
      ></el-divider>
      <div class="info-item">
        <span class="label">内容类型：</span>
        <span class="value">{{types[section.type] || '--'}}</span>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ref_type"
            label="推荐类型"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              {{types[scope.row.ref_type] || '--'}}
            </template>
          </el-table-column>
          <el-table-column
            label="内容ID"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.ref_content">{{scope.row.ref_content.id}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="内容标题"
            min-width="160"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="scope.row.ref_content">{{scope.row.ref_content.name || scope.row.ref_content.title}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="内容封面"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <img
                v-if="scope.row.ref_content"
                :src="scope.row.ref_content.picture_url"
                style="max-height: 50px;display:block;margin:0 auto;"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序值"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleSectionItemEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleSectionItemRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <SectionItemCreate
      :visible="createDialog"
      :section="section"
      @close="createDialog = false"
      @submit="fetchSectionItemList"
    ></SectionItemCreate>
    <SectionItemEdit
      :visible="editDialog"
      :section="section"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchSectionItemList"
    ></SectionItemEdit>
  </div>
</template>

<script>
import SectionItemCreate from '@/components/dialog/section/SectionItemCreate'
import SectionItemEdit from '@/components/dialog/section/SectionItemEdit'
import { sectionItemList, sectionItemDestroy, sectionOne } from '@/api/section'

export default {
  components: {
    SectionItemCreate,
    SectionItemEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {
        ref_content: {}
      },
      query: {
        section_id: this.$route.params.sectionId,
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      pageTotal: 10,
      results: [],
      section: {},
      types: { '1': '课程', '2': '题库', '3': '阅读资料', '4': '实体资料', '5': '信息资讯' },
      sites: { '1': '首页', '2': '院校页', '3': '课程页', '4': '题库页', '5': '调剂推荐页' }
    }
  },
  created() {
    this.parseQuery()
    this.fetchSectionInfo()
    this.fetchSectionItemList()
  },
  methods: {
    // 版块详情请求
    fetchSectionInfo() {
      sectionOne({ id: this.$route.params.sectionId }).then(res => {
        this.section = res
      })
    },
    // 版块子项列表请求
    fetchSectionItemList() {
      sectionItemList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 子项创建
    handleSectionItemAdd() {
      this.createDialog = true
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchSectionItemList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchSectionItemList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        '1': '正常',
        '2': '关闭'
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    handleSectionItemEdit(row) {
      this.editRow = Object.assign({}, row, { status: row.status == 1 ? true : false })
      this.editDialog = true
    },
    // 推荐删除
    handleSectionItemRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        sectionItemDestroy({ id: row.id }).then(res => {
          this.$message.success(`删除成功`)
          this.fetchSectionItemList()
        })
      }).catch(() => { })
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .info {
    display: flex;
    margin-top: 10px;

    .info-item {
      .label {
        color: #909399;
      }
      .value {
        // margin-left: 5px;
      }
    }
    .divider {
      margin: 0 20px;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
